import React, { useContext } from 'react'
import './index.scss'
import OverclaimHistoryRow from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimHistoryTab/OverclaimHistoryRow'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

const OverclaimHistoryTab = () => {
    const { overclaimViewStore } = useContext(StoresContext)
    const history = overclaimViewStore.overclaimHistory
    return (
        <div className="overclaim-history-wrapper" id="History-tab">
            <>
                <div className="title">Overclaim History</div>
                {history === undefined ? null : history.length ? (
                    <div className="history-table">
                        {history.map((row, index) => (
                            <OverclaimHistoryRow key={`${row.eventType}-${index}`} historyRow={row} />
                        ))}
                    </div>
                ) : (
                    'No actions have been taken on this work.'
                )}
            </>
        </div>
    )
}
export default observer(OverclaimHistoryTab)
